import { render, staticRenderFns } from "./subject-form-4.vue?vue&type=template&id=7f6d3816&scoped=true&"
import script from "./subject-form-4.vue?vue&type=script&lang=ts&"
export * from "./subject-form-4.vue?vue&type=script&lang=ts&"
import style0 from "./subject-form-4.vue?vue&type=style&index=0&id=7f6d3816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d3816",
  null
  
)

export default component.exports